import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  id,
  delay = 0
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.15
  }} transition={{
    duration: 0.6,
    ease: [0.16, 1, 0.3, 1],
    delay
  }} className={`py-12 md:py-20 px-6 md:px-12 max-w-7xl mx-auto w-full ${className}`} data-id="element-214">
      {children}
    </motion.section>;
}